/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';
import { Button, EmptyState } from '../console/ui';
import { FolderIc, PlusIc } from '../console/icons';

interface ProjectEmptyStateProps {
    onCreateProject: () => void;
}

const ProjectEmptyState: React.FC<ProjectEmptyStateProps> = ({ onCreateProject }) => {
    return (
        <EmptyState
            icon={<FolderIc />}
            title="No projects yet"
            body="Create a project to group pods, storage and keys by team or workload."
            actions={
                <Button onClick={onCreateProject}>
                    <PlusIc className="w-4 h-4" />
                    Create project
                </Button>
            }
        />
    );
};

export default ProjectEmptyState;
